export default __webpack_public_path__ + "static/media/ICOPresaleCard.b19d9d9a.svg";